<template>
  
  <div class="element">
    <div class="label text-caption">{{ label }}</div>
    <div class="status">{{ status }}</div>
  </div>

</template>


<script>

export default {

  // #region Properties

  name:  'StatusElement',
  props: {
    label:  String,
    status: String
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>

@import '../../../styles/colors.scss';

.element {
  display:        flex;
  flex-direction: column;

  .label {
    margin-bottom:    -4px;
    color:            $darker-label-color;          
  }

  .status {
    color:            $label-color;
  }
}

</style>